import { makeStyles } from 'tss-react/mui';
import {
  PATHOLOGY_MAP_TRANSPARENT_BLACK,
  TRANSPARENT_RED,
} from 'components/PathologyMap/constants/styles';
import { TRANSPARENT_BLACK_26, WHITE } from 'utilities/colors';

export const usePathologyMapSlideCardContentStyles = makeStyles()(() => ({
  imageWrapper: {
    '&:hover': {
      cursor: 'pointer',
    },
    marginBottom: '-6px',
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  img: {
    '&:after': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: TRANSPARENT_BLACK_26,
      zIndex: 1,
    },
  },
  overlayText: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    color: WHITE,
    fontSize: '1.75rem',
    letterSpacing: '0.1rem',
    fontWeight: 600,
    textShadow: `0 0 5px ${TRANSPARENT_BLACK_26}`,
    textTransform: 'uppercase',
    zIndex: 2,
  },
  contentWrapper: {
    padding: '0 0.5rem 0.5rem',
  },
  overlayButton: {
    zIndex: 9999,
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    border: '1px solid red',
    borderRadius: '0.25rem',
    backgroundColor: TRANSPARENT_RED,
    color: 'rgba(219, 72, 73)',
    fontSize: '1rem',
    textTransform: 'none',
    width: '7rem',
    height: '2.25rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&:hover': {
      backgroundColor: TRANSPARENT_RED,
    },
  },
  blur: {
    filter: 'blur(2px)',
  },
}));

export const usePathologyMapSlideCardHeaderStyles = makeStyles()({
  header: {
    padding: '0.5rem 0.75rem 0.5rem 1rem',
    cursor: 'pointer',
  },
});

export const usePathologyMapSlideCardItemStyles = makeStyles()({
  slideCardsContainer: {
    backgroundColor: 'white',
    borderColor: PATHOLOGY_MAP_TRANSPARENT_BLACK,
    borderRadius: '3px',
    boxShadow: `0px 8px 20px 15px ${PATHOLOGY_MAP_TRANSPARENT_BLACK}`,
    width: '100%',
  },
  slideCardViewed: {
    position: 'relative',
    '&:after': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: TRANSPARENT_BLACK_26,
      zIndex: 1,
    },
  },
});

export const usePathologyMapSlideCardItemsStyles = makeStyles()({
  snackbar: {
    minWidth: '200px !important',
  },
});
